import { render, staticRenderFns } from "./ListVehicleInspection.vue?vue&type=template&id=32968178"
import script from "./ListVehicleInspection.vue?vue&type=script&lang=js"
export * from "./ListVehicleInspection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./ListVehicleInspection.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32968178')) {
      api.createRecord('32968178', component.options)
    } else {
      api.reload('32968178', component.options)
    }
    module.hot.accept("./ListVehicleInspection.vue?vue&type=template&id=32968178", function () {
      api.rerender('32968178', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/fleet/src/views/ListVehicleInspection.vue"
export default component.exports